import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';
import { useCurrentCompany } from './useCurrentCompany';

export interface CompanySport {
  id: string;
  company_id: string;
  sport_name: string;
  category_id: string | null;
  is_primary: boolean | null;
}

export function useCompanySports() {
  const { data: companyId } = useCurrentCompany();

  return useQuery({
    queryKey: ['company-sports', companyId],
    queryFn: async () => {
      if (!companyId) return [];

      const { data, error } = await supabase
        .from('company_sports')
        .select('id, company_id, sport_name, category_id, is_primary')
        .eq('company_id', companyId)
        .order('sport_name');

      if (error) {
        console.error('Error fetching company sports:', error);
        throw error;
      }

      return (data || []) as CompanySport[];
    },
    enabled: !!companyId,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}
